type TimelineItem = {
  date: string;
  time: string;
  avatar: React.ReactNode;
  name: string;
  content: React.ReactNode;
  timestamp: string;
};

type PositionDetailTimelineProps = {
  items: TimelineItem[];
  title: string;
};

function PositionDetailTimeline({items, title}: PositionDetailTimelineProps) {
  return (
    <>
      <div className="box pr-6">
        <h4 className="px-6 pt-4 text-xl font-bold">{title}</h4>
        <ul className="timeline list-none text-[0.813rem] text-defaulttextcolor">
          {items.map((item, index) => (
            <li key={index}>
              <div className="timeline-time text-end">
                <span className="date">{item.date}</span>
                <span className="time inline-block">{item.time}</span>
              </div>
              <div className="timeline-icon"></div>
              <div className="timeline-body !mr-0 !bg-zinc-900">
                <div className="timeline-main-content mt-0 flex flex-wrap items-start">
                  <div className="avatar avatar-md online avatar-rounded me-3 mt-6 md:mt-0">{item.avatar}</div>
                  <div className="flex-grow">
                    <div className="flex items-center">
                      <div className="mt-2 sm:mt-0">
                        <p className="mb-0 text-[.875rem] font-semibold">{item.name}</p>
                        <p className="mb-0 text-[#8c9097] dark:text-white/50">{item.content}</p>
                      </div>
                      <div className="ms-auto">
                        <span className="badge timeline-badge whitespace-nowrap !bg-light text-[#8c9097] dark:text-white/50 ltr:float-right rtl:float-left">
                          {item.timestamp}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div className="timeline-loadmore-container text-center">
          {/* <button type="button" className="ti-btn ti-btn-info ti-btn-loader">
            Loading
            <span className="ti-spinner !h-4 !w-4" role="status"></span>
          </button> */}
        </div>
      </div>
    </>
  );
}

export default PositionDetailTimeline;
